import React, { useState, useEffect } from 'react';
import NavigationDrawer from '../../../../components/navigationDrawer';
import DashboardHeadear from './dashboardHeader';
import Cards from './cards';
import useStyles from './style';
import { Typography } from '@mui/material';
import Loader from '../../../../components/loader';
import DashboardChart from '../../../../components/dashboardChart';
import { getAdminDashboardData } from '../../../../services/adminDashboard';
import SnackbarAlert from '../../../../components/snackbar/SnackbarAlert';
import Swal from 'sweetalert2';

const AdminDashboard = () => {
  const classes = useStyles();
  const [isLoading, setIsLoading] = useState(false);
  const [dashboardData, setDashboardData] = useState({});
  const [chartData, setChartData] = useState([]);
  const [dateValues, setDateValues] = useState({
    startDate: null,
    endDate: null,
  });
  const [snackbarProps, setSnackbarProps] = useState({
    open: false,
    type: '',
    message: '',
  });

  let Temp = [
    'Jan',
    'Feb',
    'Mar',
    'Apr',
    'May',
    'June',
    'July',
    'Aug',
    'Sep',
    'Oct',
    'Nov',
    'Dec',
  ];

  useEffect(() => {
    let params = {};
    getData(params);
  }, []);

  const getData = (params) => {
    setIsLoading(true);
    getAdminDashboardData(params)
      .then((res) => {
        console.log(res.data, 'statusstatusstatusstatus');
        if (res.status === 400) {
          setIsLoading(false);
          Swal.fire({
            icon: 'error',
            title: 'Error',
            text: res.error,
            confirmButtonColor: 'red',
          });
        } else {
          let response = res.data.data;
          setDashboardData(response);
          setIsLoading(false);
          setDateValues({});

          // Data set
          let tempArr = [];
          response?.orderChartData?.map((val) => {
            console.log(val, 'VALLLL');
            console.log(Temp[val._id.charAt(1) - 1], 'LLLLL');
            tempArr.push({
              month: Temp[val._id.charAt(1) - 1],
              totalOrders: val.numberofbookings,
              id: val._id.charAt(1),
            });
          });
          const sortedProducts = tempArr.sort(
            (res1, res2) => res1.id - res2.id
          );
          setChartData(sortedProducts);
        }
      })
      .catch((error) => {
        console.log(error, 'asdlskdjslkjdlk');
        setIsLoading(false);
      });
  };

  const handleSubmit = () => {
    const { startDate, endDate } = dateValues;
    let params = {
      startdate: startDate?._d,
      endDate: endDate?._d,
    };

    if (endDate == null || startDate == null) {
      handleSnackbarVal(true, 'error', 'Please select both dates');
    } else {
      getData(params);
    }
  };
  const handleReset = () => {
    let params = {};
    getData(params);
  };

  const handleSnackbarVal = (open, type, message) => {
    setSnackbarProps({
      open,
      type,
      message,
    });
  };

  const handleCloseSnackbar = () => {
    handleSnackbarVal(false, '', '');
  };

  return (
    <NavigationDrawer>
      <Loader isloading={isLoading} />
      <SnackbarAlert
        snackbarProps={snackbarProps}
        handleCloseSnackbar={handleCloseSnackbar}
      />
      <DashboardHeadear
        dateValues={dateValues}
        setDateValues={setDateValues}
        handleSubmit={handleSubmit}
        handleReset={handleReset}
        type='dashboard'
      />
      <Cards dashboardData={dashboardData} />
    </NavigationDrawer>
  );
};

export default AdminDashboard;
